import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  toast?: boolean
}

const MessageBarList = ({ children, toast }: Props) => {
  return (
    <div className={clsx('mb-4 flex flex-col gap-y-0.5', toast && 'z-modal fixed top-10 right-0')}>
      {children}
    </div>
  )
}

export default MessageBarList
